import { render, staticRenderFns } from "./aShopDetailProduct.vue?vue&type=template&id=251bb31d&scoped=true"
import script from "./aShopDetailProduct.vue?vue&type=script&lang=js"
export * from "./aShopDetailProduct.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailProduct.vue?vue&type=style&index=0&id=251bb31d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251bb31d",
  null
  
)

export default component.exports